import { noop } from 'lodash';
import PropTypes from 'prop-types';
import { cloneElement, PureComponent } from 'react';

class DropdownContainer extends PureComponent {
    static propTypes = {
        onChange: PropTypes.func,
    };

    static defaultProps = {
        onChange: noop,
    };

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.selected && nextProps.selected !== prevState.selected) {
            return {
                selected: nextProps.selected,
            };
        }

        return null;
    }

    constructor(props) {
        super(props);

        this.state = {
            selected: props.selected,
        };
    }

    render() {
        return cloneElement(this.props.children, {
            onChange: this.onChange,
            selected: this.state.selected,
        });
    }

    onChange = e => {
        const newValue = e.target.value;

        this.setState({
            selected: newValue,
        });

        this.props.onChange(newValue);
    };
}

export default DropdownContainer;
